import generate from '@personnummer/generate';
import danishSsn from 'danish-ssn';
import { differenceInCalendarYears } from 'date-fns';
import { FinnishSSN } from 'finnish-ssn';

import type { Language } from '../types/types';

export const generateSsn = (birthday: string, language: Language) => {
  const birthDate = birthday.split('-').reverse().join('-');

  switch (language) {
    case 'da': {
      const ssns = danishSsn.validForDate(new Date(birthDate));
      const ssn = ssns[Math.floor(Math.random() * ssns.length)];
      return ssn as string; // NOTE: Typecasting here, as we know that this will be a string, as it is a string picked from a random index of a string array. TS thinks it can be undefined, though.
    }
    case 'fi': {
      return FinnishSSN.createWithAge(
        differenceInCalendarYears(Date.now(), new Date(birthDate))
      );
    }
    case 'sv': {
      return generate(new Date(birthDate));
    }
    default: {
      return '';
    }
  }
};
